import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LocaleStrings from "Languages";
import { Modal, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import _ from "lodash";
import QRCode from "react-qr-code";

import { BASE_IMAGES_URL, classNames } from "Constants";
// Import actions
import { togglePrintPreviewModal } from "BadgeDesignAction";

const PrintPriview = (props) => {
  let { isPrintPreviewModalOpen } = props;
  // Close modal function
  const closeModal = () => {
    props.togglePrintPreviewModal(false);
  };

  /* Show actual data
    Example - #first_name -> Tapas
    'identifierString' as name => #name */
  const showActulData = (identifierString) => {
    let text = "";
    let { eventDetails, userDetails } = props;

    if (identifierString === "#event_name") {
      text = eventDetails.eventname;
    } else if (identifierString === "#first_name" && userDetails.firstname) {
      text = userDetails.firstname;
    } else if (identifierString === "#last_name" && userDetails.lastname) {
      text = userDetails.lastname;
    } else if (identifierString === "#full_name" && userDetails.username) {
      text = userDetails.username;
    } else if (identifierString === "#designation" && userDetails.designation) {
      text = userDetails.designation;
    } else if (identifierString === "#company_name" && userDetails.company) {
      text = userDetails.company;
    } else if (
      identifierString === "#registration_type" &&
      userDetails.comesfrom
    ) {
      text = userDetails.comesfrom;
    } else if (
      identifierString === "#event_location" &&
      userDetails.eventlocation
    ) {
      text = userDetails.eventlocation;
    } else if (
      identifierString === "#primary_group" &&
      _.size(userDetails.usercategory_array)
    ) {
      let primaryGroupId = _.toString(
        _.split(userDetails.usercategory, ",", 1)
      ); // Example => 123546,7854123,498156 will take 123546
      let newPrimaryGroupArray = _.filter(userDetails.usercategory_array, {
        id: primaryGroupId,
      });
      text = newPrimaryGroupArray[0]?.groupname;
    } else {
      text = identifierString;
    }
    return text;
  };

  // Render print preview badge elements
  const renderPreviewBadgeElements = () => {
    let { templateJson, eventDetails, session, userDetails } = props;
    let eventicon = "";
    let eventlocation = "";

    if (eventDetails.eventicon)
      eventicon = `${BASE_IMAGES_URL}/${eventDetails.eventicon}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;

    if (eventDetails.eventlocation) {
      eventlocation = eventDetails.eventlocation;
    }

    let Item = _.map(templateJson, (value, index) => {
      let customStyle = { ...value.style };

      // Styling of elements
      customStyle.transform = `translate(${value.x / 2}px,${value.y / 2}px)`;
      // Remove extra elements
      delete customStyle.border;

      if (value.htmlType === "image") {
        // If iamge
        delete customStyle.top;
        delete customStyle.left;

        customStyle.width =
          parseInt(_.split(value.style.width, "px", 1)) / 2 + "px";
        customStyle.height =
          parseInt(_.split(value.style.height, "px", 1)) / 2 + "px";
      }
      if (value.htmlType === "zoominout") {
        delete customStyle.border;
        customStyle.height = customStyle.height / 2;
        customStyle.width = customStyle.width / 2;
      }
      if (value.htmlType === "div") {
        delete customStyle.width;
      }

      return !value.hidden ? (
        value.htmlType === "image" ? (
          <img
            key={`key_preview_${index}`}
            id={value.name}
            name={value.name}
            src={eventicon}
            style={customStyle}
            draggable="false"
            alt={value.name}
          />
        ) : value.htmlType === "zoominout" ? (
          <QRCode
            key={`key_preview_${index}`}
            size={256}
            // style={{
            //   height: parseInt(_.split(value.style.height, "px", 1)) / 2 + "px",
            //   maxWidth: "100%",
            //   width: "100%",
            // }}
            style={customStyle}
            value={
              userDetails.magiclink && userDetails.magiclink !== ""
                ? userDetails.magiclink
                : "appuser###encrypted###token"
            }
            viewBox={`0 0 256 256`}
          />
        ) : value.htmlType === "input" ? (
          <span key={`key_preview_${index}`} style={customStyle}>
            {_.size(value.textValue) === 0
              ? showActulData(value.name)
              : value.textValue}
          </span>
        ) : (
          <span key={`key_preview_${index}`} style={customStyle}>
            {showActulData(value.name)}
          </span>
        )
      ) : null;
    });

    return Item;
  };

  const customStyle = {
    height: props.boxSizeHeight / 2,
    width: props.boxSizeWidth / 2,
    postion: "relative",
  };

  return (
    <Modal
      className="modal-container"
      dialogClassName="modal-xl"
      show={isPrintPreviewModalOpen}
      onHide={() => closeModal()}
      animation={true}
    >
      <Modal.Header>
        <div className="import-modal-title">
          {LocaleStrings.badge_print_preview}
        </div>
        <button
          type="button"
          className="i-custom-cross-popup pull-right"
          onClick={() => closeModal()}
        >
          <img
            className="i-custom-small"
            src="../../style/images/custom-icons/cross-black.png"
          />
        </button>
      </Modal.Header>
      <Modal.Body style={{}}>
        {/* Badge */}
        <div className="badge-boundary" style={customStyle}>
          {renderPreviewBadgeElements()}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          bsStyle=""
          className="btn btn-custom-white"
          onClick={() => closeModal()}
        >
          {LocaleStrings.button_close}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    templateJson: state.templateJson,
    isPrintPreviewModalOpen: state.isPrintPreviewModalOpen,
    eventDetails: state.userEventDetails,
    userDetails: state.userDetails ? state.userDetails : [],
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ togglePrintPreviewModal }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PrintPriview);
